export default "query GetUserPreference($key: String!){\n  getUserPreference(key: $key) \n}\n"